import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { fmt } from '../../utils/formatters';

/** Bills paid — money out from a bills CSV, never mixed with sales.
 *  Moved from the Upload page (2026-09-24 five doors); its heading is an h2
 *  now because it sits directly under the Costs page's h1. */
export default function BillsList() {
  const [billVendors, setBillVendors] = useState<any[]>([]);

  const fetchBills = () => {
    axios.get('/api/bills')
      .then((res) => setBillVendors(res.data?.by_vendor || []))
      .catch(() => setBillVendors([]));
  };

  useEffect(() => { fetchBills(); }, []);

  if (billVendors.length === 0) return null;

  return (
    <div className="mt-8 bg-white border border-[#E6E2DE] rounded-[14px] p-6 shadow-card">
      <h2 className="font-serif text-lg text-[#2D2A2E] mb-3">Bills paid</h2>
      <div className="divide-y divide-[#E6E2DE]">
        {billVendors.slice(0, 10).map((v) => (
          <div key={v.vendor} className="flex items-center justify-between py-2.5">
            <span className="font-sans text-sm text-[#2D2A2E]">{v.vendor}</span>
            <span className="font-sans text-sm text-[#6B6670] tabular-nums">
              {v.count} {v.count === 1 ? 'bill' : 'bills'} · {fmt(v.total)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
